// extracted by mini-css-extract-plugin
export default {"mainButton":"InvoiceDetailsHeader_mainButton__gtYho"};